import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-card text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="العليمي" className="h-12 w-12" />
              <div className="flex flex-col">
                <span className="text-xl font-bold">العليمي</span>
                <span className="text-sm text-muted-foreground">لاستضافة المواقع</span>
              </div>
            </div>
            <p className="text-muted-foreground leading-relaxed mb-6">
              نوفر حلول استضافة مواقع متقدمة وموثوقة بأفضل الأسعار في المنطقة. 
              مع دعم فني على مدار الساعة وأداء عالي الجودة.
            </p>
            <div className="flex flex-col gap-3 text-muted-foreground">
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[#4A9FD8]" />
                <span>info@alalimi.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[#4A9FD8]" />
                <span dir="ltr">+966 506774628</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin size={18} className="text-[#4A9FD8]" />
                <span>جدة، المملكة العربية السعودية</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">روابط سريعة</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-muted-foreground hover:text-[#4A9FD8] transition-colors">

                  المميزات
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="!font-bold !text-lg mb-4">روابط هامة</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-muted-foreground hover:text-[#4A9FD8] transition-colors">

                  سياسة الخصوصية
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-muted-foreground hover:text-[#4A9FD8] transition-colors">

                  الشروط والأحكام
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-8">
          <p className="text-center text-muted-foreground">
            جميع الحقوق محفوظة لـ <span className="text-[#4A9FD8] font-semibold">العليمي لاستضافة المواقع</span> © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;